import React, { useContext } from 'react';

import DeviceInterfaceTable from '@totem/components/networkConcerns/deviceInterfaceTable';
import NetworkConcernsContext from '@totem/components/networkConcerns/networkConcernsContext';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import { isNotNull } from '@totem/utilities/common';

const NetworkConcernsLayout = () => {
  const { reportData, interfaceData } = useContext(NetworkConcernsContext);
  return (
    <div>
      <IBTabs
        defaultActiveKey={'Concerns'}
        items={[
          {
            key: 'Concerns',
            label: 'Concerns',
            children: (
              <>
                <b>Multiple Adapters Active: </b>
                <br />
                <DeviceInterfaceTable
                  data={
                    isNotNull(reportData) ? reportData.multipleAdapters : []
                  }
                />
                <b>Wireless Adapters Active: </b>
                <br />
                <DeviceInterfaceTable
                  data={
                    isNotNull(reportData) ? reportData.wirelessAdapters : []
                  }
                />
              </>
            ),
          },
          {
            key: 'Unapproved Interfaces',
            label: 'Unapproved Interfaces',
            children: (
              <>
                <br />
                <DeviceInterfaceTable
                  data={
                    isNotNull(interfaceData)
                      ? interfaceData
                          .map((item) => ({
                            ...item,
                            interfaces: item.interfaces.filter(
                              (iface) => !iface.approved,
                            ),
                          }))
                          .filter((chk) => chk.interfaces.length >= 0)
                      : []
                  }
                />
              </>
            ),
          },
          {
            key: 'All Interfaces',
            label: 'All Interfaces',
            children: (
              <>
                <br />
                <DeviceInterfaceTable
                  data={isNotNull(interfaceData) ? interfaceData : []}
                />
              </>
            ),
          },
        ]}
      />
    </div>
  );
};

export default NetworkConcernsLayout;
